import { useIntl } from 'react-intl'
import { LightStatuses } from '../styles'
import { lightStatusesMessages } from './messages'
import HomeLightStatus from './LightStatus'
import type { StatusState } from '@racepointenergy/swc/scs/features/host-states'
import { StatusLight } from '@racepointenergy/swc/scs/types/host'
import { EntityState } from '@reduxjs/toolkit'

interface HomeLightStatusesProps {
  entities: EntityState<StatusState>['entities']
}

function HomeLightStatuses({ entities }: HomeLightStatusesProps) {
  const { formatMessage } = useIntl()

  const control = entities['global.ControlStatus']
  const diagnostic = entities['global.DiagnosticReportStatus']
  const controller = entities['global.ControllerStatus']

  return (
    <LightStatuses>
      <HomeLightStatus
        label={formatMessage(lightStatusesMessages.statusesListConnectionTitle)}
        colorIdx={control?.light ?? StatusLight.Grey}
        status={control?.status ?? ''}
      />
      <HomeLightStatus
        label={formatMessage(lightStatusesMessages.statusesListReportsTitle)}
        colorIdx={diagnostic?.light ?? StatusLight.Grey}
        status={diagnostic?.status ?? ''}
      />
      <HomeLightStatus
        label={formatMessage(lightStatusesMessages.statusesListControllerTitle)}
        colorIdx={controller?.light ?? StatusLight.Grey}
        status={controller?.status ?? ''}
      />
    </LightStatuses>
  )
}

export default HomeLightStatuses
